import React from 'react';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import { navigate } from '@reach/router';

import classes from './mailbox.module.scss';
import { formatDate } from '../../utils/dateUtils';

const ChatList = ({ userChats }) => {
  return userChats && userChats.length !== 0 ? (
    <List>
      {userChats.map((chat: any) => {
        const classesArr = [
          classes.noWrap,
          chat.unread ? classes.unread : null
        ];
        const dateClasses = [classes.date, ...classesArr];
        const unread = chat.unread ? ` (${chat.unread})` : '';
        return (
          <ListItem
            alignItems="flex-start"
            key={chat.id}
            onClick={() => navigate('/mailbox/' + chat.id)}
            style={{ cursor: 'pointer' }}
          >
            <ListItemAvatar>
              <Avatar alt={chat.product.name} src={chat.product.image} />
            </ListItemAvatar>
            <ListItemText
              classes={{ secondary: classesArr.join(' ') }}
              primary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    className={classesArr.join(' ')}
                    color="textPrimary"
                  >
                    {chat.from}, {chat.product.name} {unread}
                  </Typography>
                  <Typography
                    component="span"
                    variant="body2"
                    className={dateClasses.join(' ')}
                    color="textPrimary"
                  >
                    {formatDate(chat.lastMessage.createdAt)}
                  </Typography>
                </React.Fragment>
              }
              secondary={`${chat.lastMessage.author.firstName}: ${
                chat.lastMessage.text
              }`}
            />
          </ListItem>
        );
      })}
    </List>
  ) : (
    <Paper elevation={0} className={classes.noChats}>
      <Typography variant="h5" component="p">
        Діалогів поки що немає.
      </Typography>
    </Paper>
  );
};

export default ChatList;
